import React from 'react';
//@ts-ignore
import Idle from 'react-idle';
import { useDispatch } from 'react-redux';
import { UserActions } from '../../../libs/IdeLink.Web.Common/src/modules/User/UserActions';

export interface RefreshIfNeededProps {
    timeout: number;
    children?: React.ReactNode;
}

//! timeout: 600000, // 1h in ms

export const RefreshIfNeeded = ({ timeout = 600000, children }: RefreshIfNeededProps) => {
    const dispatch = useDispatch();
    const setIdle = (idle: boolean) => dispatch(UserActions.setIdle(idle));

    return (
        <Idle
            timeout={timeout}
            onChange={({ idle }: any) => setIdle(idle)}
            render={({ idle }: any) => children}
        />
    );
};
